<template>
    <div id="loader">
        <p>Loading...</p>
    </div>
</template>

<script>
  export default {
    name: 'Loader'
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/UIComponents/Custom/LoaderCustom.vue